var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWrapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 59.5,
    stroke: "#EEF4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 103,
    height: 103,
    rx: 51.5,
    stroke: "#E0EAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "#A4BCFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0003 60L55.0003 70L75.0003 50M93.3337 60C93.3337 78.4095 78.4098 93.3333 60.0003 93.3333C41.5908 93.3333 26.667 78.4095 26.667 60C26.667 41.5905 41.5908 26.6666 60.0003 26.6666C78.4098 26.6666 93.3337 41.5905 93.3337 60Z",
    stroke: "#444CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWrapper);
export default __webpack_public_path__ + "static/media/check-wrapper.5eba13bae6856524dd9de37e9491618e.svg";
export { ForwardRef as ReactComponent };